<script setup>
import Provider from "./Provider.vue";
import { onMounted, ref } from "vue";
import HandleCache from "@/HandleCache.vue";
const cacheBuster = ref();
import { BRAND, EXTRA_BRAND, BRAND_PLAN_LIMITS } from "@/constants/graphql";
import { useQuery } from "@urql/vue";
import { useBrandStore } from "@/stores/brand.js";
import { usePlanLimitStore } from "@/stores/planLimit";

const store = useBrandStore();
const planStore = usePlanLimitStore();
const result = useQuery({
  query: BRAND,
  variables: {},
  pause: true,
});

const extraQuery = useQuery({
  query: EXTRA_BRAND,
  variables: {},
  pause: true,
});

store.$patch({ query: result, extraQuery: extraQuery });

const planLimitQuery = useQuery({
  query: BRAND_PLAN_LIMITS,
  variables: {},
  pause: true,
});

planStore.$patch({ query: planLimitQuery });
</script>

<template>
  <HandleCache ref="cacheBuster">
    <template v-slot="{ isLoading, isLatestVersionAvailable }">
      <h1 v-if="isLoading">Loading...</h1>
      <template v-else-if="isLatestVersionAvailable">
        <suspense>
          <Provider>
            <router-view></router-view>
          </Provider>
        </suspense>
      </template>
      <template v-else>
        {{ cacheBuster.clearCacheAndReload() }}
      </template>
    </template>
  </HandleCache>
</template>
